import 'core-js/modules/es.string.includes.js';
import { AssetType } from '../domain/dtos/asset-type.js';

class GetAssetSize {
  execute(asset) {
    const {
      type,
      metadata
    } = asset;
    if (!type || !(metadata === null || metadata === void 0 ? void 0 : metadata.size)) {
      return 0;
    }
    if ([AssetType.image, AssetType.application, AssetType.video].includes(type)) {
      return metadata.size;
    }
    return 0;
  }
}

export { GetAssetSize };
